import { render, staticRenderFns } from "./2ViaCartao.vue?vue&type=template&id=0d4e5e02&scoped=true&"
import script from "./2ViaCartao.vue?vue&type=script&lang=js&"
export * from "./2ViaCartao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4e5e02",
  null
  
)

export default component.exports